<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import axios from 'axios';

import Banner from 'dashboard/components-next/banner/Banner.vue';

const VERSION_CHECK_INTERVAL = 60 * 1000;

const { t } = useI18n();
const showUpdateBanner = ref(false);
let loadedDeploymentId = window.globalConfig?.GIT_SHA;
let versionCheckTimer;

const checkDeploymentVersion = async () => {
  if (showUpdateBanner.value) return;

  try {
    const { data } = await axios.get('/api/version', {
      params: { cacheBust: Date.now() },
    });
    const deploymentId = data?.deployment_id;

    if (!deploymentId) return;
    if (!loadedDeploymentId) {
      loadedDeploymentId = deploymentId;
      return;
    }

    showUpdateBanner.value = deploymentId !== loadedDeploymentId;
  } catch {
    // Network failures are handled by NetworkNotification.
  }
};

const checkWhenVisible = () => {
  if (document.visibilityState === 'visible') checkDeploymentVersion();
};

const refreshPage = () => {
  window.location.reload();
};

onMounted(() => {
  checkDeploymentVersion();
  versionCheckTimer = window.setInterval(
    checkDeploymentVersion,
    VERSION_CHECK_INTERVAL
  );
  document.addEventListener('visibilitychange', checkWhenVisible);
});

onBeforeUnmount(() => {
  window.clearInterval(versionCheckTimer);
  document.removeEventListener('visibilitychange', checkWhenVisible);
});
</script>

<template>
  <Banner
    v-show="showUpdateBanner"
    color="blue"
    :action-label="t('SYSTEM_UPDATE.REFRESH')"
    class="!rounded-none !justify-center"
    @action="refreshPage"
  >
    <span class="text-xs font-medium">
      {{ t('SYSTEM_UPDATE.MESSAGE') }}
    </span>
  </Banner>
</template>
